import { useEffect } from "react";
import { Link } from "react-router-dom";
import { OFFER } from "../config/offer.config";
import { trackViewContent } from "../lib/pixel";

/**
 * Landing minimal single-CTA (retargeting / audiencia caliente): una promesa,
 * un botón, cero distracciones.
 */
export default function LandingMinimal() {
  useEffect(() => trackViewContent("landing_minimal"), []);
  return (
    <main className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="font-sans text-xs uppercase tracking-[0.2em] text-clay">
        A Couple &amp; A Dream · {OFFER.serviceArea.join(", ")}
      </p>
      <h1 className="mt-5 max-w-2xl font-serif text-5xl leading-tight text-ink md:text-6xl">
        Imagine starting every morning in a spa. In your own home.
      </h1>
      <p className="mt-5 max-w-lg text-lg text-stone">
        Design and construction under one roof. Build your bathroom and discover your
        tentative investment range in two minutes.
      </p>
      <Link
        to="/estimator"
        className="mt-8 inline-block rounded-md bg-ink px-8 py-3 font-sans text-sm uppercase tracking-widest text-bone transition hover:bg-clay"
      >
        Discover your range →
      </Link>
    </main>
  );
}
